var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row div-valign" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("\n        เลขที่สัญญา\n        ")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.ctrNo,
              expression: "ctrNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{ required:true}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("ctrNo") },
          attrs: { name: "ctrNo", "data-vv-as": "เลขที่สัญญา", type: "text" },
          domProps: { value: _vm.ctrNo },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.ctrNo = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("ctrNo"),
                expression: "errors.has('ctrNo')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("ctrNo")))]
        )
      ]),
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("label", [_vm._v("วันที่ลงสัญญา\n        ")]),
          _c("date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{ required:true}"
              }
            ],
            ref: "ctrDate",
            class: { input: true, "is-danger": _vm.errors.has("ctrDate") },
            attrs: {
              name: "ctrDate",
              format: "DD/MM/YYYY",
              "data-vv-as": "วันที่ลงสัญญา",
              lang: "th",
              placeholder: ""
            },
            model: {
              value: _vm.ctrDate,
              callback: function($$v) {
                _vm.ctrDate = $$v
              },
              expression: "ctrDate"
            }
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("ctrDate"),
                  expression: "errors.has('ctrDate')"
                }
              ],
              staticClass: "help is-danger"
            },
            [_vm._v(_vm._s(_vm.errors.first("ctrDate")))]
          )
        ],
        1
      ),
      _c("div", { staticClass: "form-group col-md-12" }, [
        _c("label", [
          _vm._v("\n        รายละเอียดโครงการ/รายละเอียดสัญญา\n        ")
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.beneficiaryRemark,
              expression: "beneficiaryRemark"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{ required:true}"
            }
          ],
          staticClass: "form-control",
          class: {
            input: true,
            "is-danger": _vm.errors.has("beneficiaryRemark")
          },
          attrs: {
            name: "beneficiaryRemark",
            "data-vv-as": "รายละเอียดโครงการ/รายละเอียดสัญญา",
            type: "text"
          },
          domProps: { value: _vm.beneficiaryRemark },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.beneficiaryRemark = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("beneficiaryRemark"),
                expression: "errors.has('beneficiaryRemark')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("beneficiaryRemark")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }